export enum EvaluationStates {
    notStarted = "NotStarted",
    deploying = "Deploying",
    started = "Started",
    ended = "Ended",
    deployFailed = "DeployFailed"
}


// WEBPACK FOOTER //
// ./src/app/models/evaluationState.ts